var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"skip-btn",on:{"click":function($event){return _vm.$emit('navClicked', 'skip')}}},[_c('span',[_vm._v("SKIP >")])]),_c('div',{staticClass:"below-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }